<template>
  <div class="department-select">
    <div class="title" @click="drawer = true">{{ showText || '全公司' }}</div>
    <i v-if="!showText" class="icon-arrow-down-s-line t-iconfont" @click="drawer = true"></i>
    <i v-else class="icon-close-circle-line t-iconfont" @click="handClearDepart"></i>
    <el-drawer v-model="drawer" direction="btt" :show-close="false" size="80%" :with-header="false">
      <div class="drawer-content">
        <div class="head">
          <div class="left"></div>
          <div class="center">部门</div>
          <div class="right">
            <i class="icon-close-line t-iconfont" @click="drawer = false"></i>
          </div>
        </div>
        <div class="content">
          <van-cell-group inset>
            <van-field
              v-model="search"
              placeholder="搜索部门"
              @update:model-value="nodeFilterChangeHandler"
            />
          </van-cell-group>
          <el-tree
            ref="treeRef"
            check-on-click-node
            :data="departmentList"
            :default-expanded-keys="defaultExpandedKeys"
            :expand-on-click-node="false"
            :filter-node-method="filterDepartNode"
            highlight-current
            node-key="pid"
            :props="defaultProps"
            @node-click="nodeClick"
          >
            <template #default="{ node }">
              <span class="ai-depart-node-name-app" v-html="addNodeByWX(node.label, 1)"></span>
            </template>
          </el-tree>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getDepartmentlist } from '@/api/ai-board'
import { addNodeByWX } from '@/utils/wx-node.js'

defineProps({
  value: {
    type: [String, Number],
    default: ''
  }
})

const emits = defineEmits(['update:value', 'departChange'])

const treeRef = ref(null)
const drawer = ref(false)
const search = ref('')
const showText = ref('')
const departmentList = ref([])
const defaultExpandedKeys = ref([])

const defaultProps = ref({
  children: 'nodes',
  label: 'text'
})

const filterDepartNode = (value, data) => {
  if (!value) return true
  return data.text.indexOf(value) !== -1
}

// 节点点击事件
const nodeClick = (node) => {
  const { pid, text, disabled } = node
  if (disabled) return
  showText.value = text
  emits('update:value', pid)
  emits('departChange', pid)
  drawer.value = false
}

const nodeFilterChangeHandler = (val) => {
  treeRef.value.filter(val)
}

const handClearDepart = () => {
  showText.value = ''
  emits('update:value', '')
  emits('departChange', '')
}

onMounted(() => {
  getDepartmentlist({
    assistantAlias: 'meeting'
  })
    .then((res) => {
      departmentList.value = res.result.departmentTree
      defaultExpandedKeys.value = [departmentList.value[0].pid]
    })
    .catch((err) => {
      console.log(err)
    })
})
</script>

<style lang="scss" scoped>
.department-select {
  flex: 0 0 auto;
  width: 132px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f7f8fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  .title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  :deep(.el-drawer) {
    border-radius: 20px 20px 0px 0px;
  }
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    .left {
      flex: 0 0 52px;
    }
    .right {
      flex: 0 0 52px;
      text-align: right;
      color: #969799;
      font-size: 20px;
    }
    .head {
      flex: 0 0 auto;
      overflow: hidden;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 13px 16px;
      /* 三级文字/常规 */
      font-family: PingFang SC;
      font-size: 16px;
      line-height: 22px;

      color: #323233;
    }
    .content {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      :deep(.van-field) {
        background: #f7f8fa;
      }
      :deep(.van-cell) {
        padding: 6px 16px;
      }
      :deep(.el-tree) {
        padding: 16px;
        overflow-y: auto;
        .el-tree-node__content {
          height: 38px;
          box-sizing: border-box;
        }
      }
      :deep(.van-cell-group--inset) {
        flex: 0 0 auto;
        margin: 12px;
      }
    }
  }
}
</style>

<style>
.ai-depart-node-name-app {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
